var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedNumberTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.038 15.166C12.038 14.844 12.08 14.69 12.206 14.522C12.304 14.396 12.458 14.27 12.682 14.144C12.92 14.018 13.41 13.794 14.152 13.472C16.056 12.632 16.924 11.694 16.924 10.308C16.924 8.628 15.482 7.382 13.452 7.382C11.212 7.382 9.742 8.656 9.616 10.77L11.604 10.924C11.702 9.804 12.346 9.202 13.452 9.202C14.362 9.202 14.922 9.622 14.922 10.294C14.922 10.994 14.418 11.414 12.738 12.128C11.548 12.632 10.82 13.094 10.358 13.64C9.952 14.102 9.756 14.76 9.756 15.614V17H16.84V15.166H12.038Z",
    fill: "#201E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedNumberTwo);
export default __webpack_public_path__ + "static/media/rounded-number-two.1b0779b2446df61fa0313232a3dbc0c8.svg";
export { ForwardRef as ReactComponent };